import { render, staticRenderFns } from "./ChatArea.vue?vue&type=template&id=be196c3a&scoped=true"
import script from "./ChatArea.vue?vue&type=script&lang=js"
export * from "./ChatArea.vue?vue&type=script&lang=js"
import style0 from "./ChatArea.vue?vue&type=style&index=0&id=be196c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be196c3a",
  null
  
)

export default component.exports